const useRoute = () => {
    const fetchPage = (page: string) => {
        var screens = JSON.parse(localStorage.getItem("screens") || '{}');
        const value = screens.length !== undefined ? screens.find((value: any) => page.includes(value.toPage)) : undefined;
        return value !== undefined ? true : false;
    };
    return { fetchPage };
}

export default useRoute;